import PptxGenJS from 'pptxgenjs';
import PowerPointSlideProcessor from '@app/services/export/ppt/slides/PowerPointSlideProcessor';
import ICooperationSlideData from '@app/types/data/slides/ICooperationSlideData';
import {
	createBadgeForSlide,
	createImageForSlide,
	createLogoForSlide,
	getBadgeWidthFromText
} from '@app/services/export/ppt/utils/layoutUtils';
import { copy, h2, h3 } from '@app/services/export/ppt/variables/typography';
import { gridCol, gridColWidth, gridColX } from '@app/services/export/ppt/utils/gridUtils';
import {
	colors,
	defaultViewPortPadding,
	elementSizes,
	presentationDimensions
} from '@app/services/export/ppt/variables/constants';
import { richTextToPptxText } from '@app/services/export/ppt/utils/formattingUtils';
import { TextWithDimensions } from '@app/services/export/ppt/classes/TextWithDimensions';

export default class PowerPointCooperationSlideProcessor extends PowerPointSlideProcessor<ICooperationSlideData> {
	public async processSlideData(): Promise<void> {
		const slide: PptxGenJS.Slide = this.presentation.addSlide();
		const topImageWidth = presentationDimensions.w;
		const topImageHeight = presentationDimensions.h / 3;
		const contentY = topImageHeight + defaultViewPortPadding.vertical;

		const headlineWithDimensions = new TextWithDimensions({
			text: this.slideData.headline,
			textOptions: {
				...h2,
				color: colors.blue
			},
			maxWidth: gridColWidth(9)
		});

		const headlineHeight = headlineWithDimensions.getDimensions().h;
		const textY = contentY + headlineHeight + 0.15;
		const textHeight = presentationDimensions.h - contentY - headlineHeight - defaultViewPortPadding.vertical;

		// top image
		createImageForSlide(slide, this.slideData.image, {
			destinationWidth: topImageWidth,
			destinationHeight: topImageHeight,
			type: 'cover'
		});

		// divider
		slide.addShape('line', {
			line: {
				color: colors.lightGray,
				width: 1
			},
			y: contentY,
			x: gridColX(2.5),
			w: 0,
			h: presentationDimensions.h - contentY - defaultViewPortPadding.vertical
		});

		// logo
		if (this.slideData.affiliateLogo) {
			createImageForSlide(slide, this.slideData.affiliateLogo, {
				destinationWidth: gridColWidth(2),
				x: gridColX(0),
				y: contentY,
				fallbackExtension: 'png'
			});
		}

		// headline
		headlineWithDimensions.createForSlide(slide, { x: gridColX(3), y: contentY });

		// subline
		slide.addText(this.slideData.subline, {
			...h3,
			...gridCol(3, 3),
			y: textY,
			h: textHeight,
			color: colors.blue,
			align: 'left',
			valign: 'top',
			margin: [0, 0, 0, 0]
		});

		// copy
		slide.addText(richTextToPptxText(this.slideData.copy), {
			...copy,
			...gridCol(6.5, 5.5),
			y: textY,
			h: textHeight,
			color: colors.blue,
			align: 'left',
			valign: 'top',
			margin: [0, 0, 0, 0]
		});

		// badge
		if (this.slideData.badgeText) {
			createBadgeForSlide(slide, this.slideData.badgeText, {
				x:
					presentationDimensions.w -
					getBadgeWidthFromText(this.slideData.badgeText) -
					defaultViewPortPadding.horizontal,
				y: topImageHeight - elementSizes.badgeHeight / 2
			});
		}

		createLogoForSlide(slide);
	}
}
